import React from "react";
import { Route, Switch } from "react-router-dom";

import routes from "./routes";
import Error404 from "./modules/common/pages/Error404";
import Auth from "./modules/auth/Auth";

const AppRoutes = () => {
  return (
    <Switch>
      <Route path={routes.AUTH} component={Auth} />
      <Route component={Error404} />
    </Switch>
  );
};

export default AppRoutes;
